<template>
  <div>
    <div class="row row-cols-1 row-cols-md-6 g-4 h-100 mt-3">
      <div class="col" v-for="sessionItem in sessionlist">
        <button class="btn w-100 h-100" data-bs-dismiss="offcanvas" v-on:click="selectSession(sessionItem.id)"
                v-bind:class="sessionItem.id === selectedSession ?'btn-success' : 'btn-outline-primary'"
        >
          {{ sessionItem.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "GroupSelectionSessions",
  data: function () {
    return {
    }
  },
  computed: {
    ...mapState(['themes', 'selectedType']),
    ...mapState('session', ['selectedSession', 'sessionlist']),
    selectedSessionComp: {
      get() {
        return this.selectedSession
      },
      set(id) {
        this.setSelectedSession(id);
      }
    },
    selectedTypeComp: {
      get() {
        return this.selectedType
      },
      set(id) {
        this.setSelectedType(id);
      }
    }
  },
  methods: {
    ...mapMutations(['setSelectedView', 'setSelectedType']),
    ...mapMutations('session', ['setSelectedSession']),
    selectSession(session_id) {
      this.setSelectedView('session');
      this.$store.dispatch('TRACK_ACTION', {'value': session_id, 'action': 'view/session', 'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME});
      this.selectedSessionComp = session_id;
      this.$emit('push');
    }
  }
}
</script>

<style scoped>

</style>
